module.exports = __webpack_public_path__ + "img/defaultBook.e1a46773.png";